import { useMemo } from "react";
import useUserAccount from "./use_user_account";

export function useUserPermissions() {
  const { data: currentUser } = useUserAccount();
  return useMemo(() => {
    return currentUser == null ? [] : currentUser.permissions;
  }, [currentUser]);
}
